import axios, { isAxiosError } from "axios";
import { store } from "../store";
import { setUser } from "../store/features/authSlice";
import { API_BASE } from "../Utils/constant";
import { api } from "./api";
import { toast } from "react-toastify";
import { save } from "../helpers/StorageHelper";
// import { db } from "../Utils/firebase";
// import { doc, getDoc, updateDoc } from "firebase/firestore";

export const login = (credentials) => {
  return new Promise((res, rej) => {
    fetch(`${API_BASE}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(credentials),
    })
      .then((response) => {
        if (!response.ok) {
          rej("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.data.token) {
          save("token", data.data.token);
          if (data.data.user) {
            store.dispatch(setUser(data.data.user));
          }
          res(data.data.user);
        } else {
          rej(data.data || "Invalid credentials. Please try again.");
        }
      })
      .catch((error) => {
        rej(error);
      });
  });
};

export const getProfile = async () => {
  try {
    const response = await api.get(`/user/profile`);
    const user = response.data?.data?.user;

    if (!user || !user.id) {
      throw new Error("Invalid or missing user");
    }

    store.dispatch(setUser(user));
    return user;
  } catch (error) {
    toast.error("Failed to fetch user profile.");
    throw error;
  }
};
